import { Component } from "react";

/**
 * react-globe.gl / WebGL can throw on unsupported GPUs or strict privacy modes.
 * Isolating failures keeps the rest of the landing page usable.
 */
export default class GlobeErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(error) {
    console.error("[Bringy] Globe/WebGL failed:", error);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          className="absolute inset-0 z-0 bg-gradient-to-br from-[#0D1B2A] via-[#152a45] to-[#0D1B2A]"
          aria-hidden
        />
      );
    }
    return this.props.children;
  }
}
